export const strategyOptions = [
    { value: 'afb.min.amount.fee', label: 'Estrategia Monto Mínimo' },
    { value: 'afb.transactionality.fee', label: 'Estrategia Transaccionalidad' },
    { value: 'afb.transactionality.fee.vip', label: 'Estrategia Transaccionalidad VIP' },
];

export const strategyLabel = (value: string) =>
    strategyOptions.find(o => o.value === value)?.label ?? value;